module.exports = __webpack_public_path__ + "img/logo-magyarnet.69cc6d7.png";